import { render, staticRenderFns } from "./AppBreadcrumb.vue?vue&type=template&id=8d58b98c&"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d58b98c')) {
      api.createRecord('8d58b98c', component.options)
    } else {
      api.reload('8d58b98c', component.options)
    }
    module.hot.accept("./AppBreadcrumb.vue?vue&type=template&id=8d58b98c&", function () {
      api.rerender('8d58b98c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/AppBreadcrumb.vue"
export default component.exports